import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiAccessService} from '../../services/network/api-access.service';

@Component({
  selector: 'app-federated-login',
  templateUrl: './federated-login.component.html',
  styleUrls: ['./federated-login.component.css'],
})
export class FederatedLoginComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router :Router) {
    this.route.params.subscribe(params => {
      const key: string = params['key'];

      const underscoreIndex = key.indexOf('_');

      const webUserId = key.substring(0, underscoreIndex);
      const integrationCode = key.substring(underscoreIndex + 1, key.length);

      ApiAccessService.fromFederatedLogin = true;
      ApiAccessService.setLoginInfo(webUserId, integrationCode);

      router.navigateByUrl('/home');
    });
  }

  ngOnInit() {}
}
